import React from 'react';
import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';
import { Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import './SystemStyles.scss';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  return (
    <div className="not-found-page-wrapper">
      <div className="login-background" />
      <div className="not-found-page">
        <div className="not-found-block-wrapper">
          <div className="not-found-block-border">
            <div className="not-found-block">
              <div className="text-1">404</div>
              <div className="text-2">{formatMessage({ id: 'menu.notFound' })}</div>
              <div className="text-3">
                <Button
                  className="big"
                  onClick={() => {
                    navigate(window.baseRoute || '/');
                  }}
                >
                  {formatMessage({ id: 'back.to.main' })}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
